export const SERVER_PATH = `https://characterize-backend.herokuapp.com`;
